import {create} from "zustand";

interface OnlineStatusStore {
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
}

/**
 * Zustand hook for managing and updating the user's online/offline status.
 * 
 * - Initializes `isOnline` using the browser's `navigator.onLine` API.
 * - Provides `setIsOnline` to manually update the status.
 */
const useOnlineStatusStore = create<OnlineStatusStore>((set) => ({
  isOnline: navigator.onLine,

  setIsOnline: (online) => {
    set({ isOnline: online });
  },
}));

export default useOnlineStatusStore;
